export default __webpack_public_path__ + "static/media/default.f8510b5444b15060c97cef756f48d5a1.png";